import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=15a5bc20&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"
import style0 from "./Carousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a5bc20')) {
      api.createRecord('15a5bc20', component.options)
    } else {
      api.reload('15a5bc20', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=15a5bc20&", function () {
      api.rerender('15a5bc20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/Carousel.vue"
export default component.exports